import React from 'react';

const RequiredNote = (props) =>{
    return (<span style={{color: "red"}}>*</span>)
}

export default RequiredNote;